"use client"

import { getApps, initializeApp, type FirebaseApp } from "firebase/app"
import { getAuth, GoogleAuthProvider, type Auth } from "firebase/auth"

/**
 * Firebase client — the SAME project as the FSP app, so a person signs in once
 * with the account they already have.
 *
 * authDomain is deliberately `app.futureofsports.io`, NOT the default
 * `<project>.firebaseapp.com`: this project's Google provider uses a custom
 * OAuth client, and only the redirect URIs registered on it will work. Every
 * other FSP surface uses this exact value.
 *
 * The apiKey is a public client identifier, not a secret — it ships in every
 * FSP web page already.
 */
const config = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY ?? "AIzaSyDrgQPOdmHCMJt-VLTxjuequmO0EkLwylg",
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN ?? "app.futureofsports.io",
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID ?? "fsp-us-prod-499705",
}

/** Email domains allowed into Workflows. Mirrors the other internal tools. */
export const ALLOWED_DOMAINS = ["futureofsports.io", "leaguesportsco.com"] as const

export function isAllowedEmail(email: string | null | undefined): boolean {
  const domain = String(email ?? "").toLowerCase().split("@")[1]
  return ALLOWED_DOMAINS.includes(domain as (typeof ALLOWED_DOMAINS)[number])
}

let app: FirebaseApp | undefined
let auth: Auth | undefined

export function getFirebaseAuth(): Auth {
  if (!app) app = getApps().length ? getApps()[0]! : initializeApp(config)
  if (!auth) auth = getAuth(app)
  return auth
}

export function googleProvider() {
  const provider = new GoogleAuthProvider()
  // `hd` narrows Google's account chooser to the primary work domain. It is a
  // HINT for the picker, never enforcement — the real check happens against
  // the signed token, on both client and server.
  provider.setCustomParameters({ hd: "futureofsports.io", prompt: "select_account" })
  return provider
}
